import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import Sentry from "./common/utils/middleware/config.sentry";
import { obtainEnvironment } from "./common/config/utils/enviroment";
import { AuthKeycloak, ClarityProvider } from "@artprov/design-system";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("No se encontró el elemento root");
}

window.addEventListener("error", (event) => {
  if (event.error?.name === "NotFoundError") {
    Sentry.captureException(event.error, {
      mechanism: { handled: true, type: "global-dom-error" },
    });
    window.location.reload();
  }
});

ReactDOM.createRoot(rootElement).render(
  <AuthKeycloak
    keycloakConfig={{
      url: import.meta.env.VITE_KEYCLOAK_URL,
      realm: import.meta.env.VITE_KEYCLOAK_REALM,
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    }}
    apiConfig={{
      consumidor: "PORTAL",
      services: [
        {
          name: "coreAuthKeycloak",
          baseURL: obtainEnvironment(import.meta.env.VITE_ENTORNO),
        },
      ],
    }}
  >
      <ClarityProvider
        projectId={import.meta.env.VITE_CLARITY_ID}
        sentry={Sentry}
      >
        <App />
      </ClarityProvider>
    </AuthKeycloak>
);
